import React from 'react';

export interface RadioGroupContextType {
  /**
   * If `true`, all the radio buttons within the group will be disabled, preventing user interaction.
   * @default false
   */
  disabled?: boolean;
  /**
   * The common name for all radio buttons within the group.
   * This is used to group the radio buttons together semantically in the DOM.
   */
  name?: string;
  /**
   * This is a callback function that is fired when the state of any radio button within the group is changed.
   * The event object of the radio button that triggered the change is passed as an argument.
   */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * If `true`, all the radio buttons within the group will be read-only,
   * preventing the user from changing the value but allowing them to interact with the component.
   * @default false
   */
  readOnly?: boolean;
  /**
   * If `true`, the user must select one of the radio buttons within the group before submitting a form.
   * @default false
   */
  required?: boolean;
  /**
   * The current value of the radio group. This is usually the value of the selected radio button within the group.
   */
  value: null | string;
}

export const RadioGroupContext = React.createContext<null | RadioGroupContextType>(null);
